import React from "react"
import CustomCard from "components/Atoms/CustomCard"
import StockManagementHeader from "./StockManagementHeader"
import { Outlet } from "react-router-dom"

const SellableItemStocks = () => {
  return (
    <div className="p-3">
      <CustomCard className="p-0">
        <StockManagementHeader />
        <Outlet />
      </CustomCard>
    </div>
  )
}

export default SellableItemStocks
